
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Instagram from "../pages/instagram/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/instagram",
    element: <Instagram />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
